import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  computed
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { RelativeTimeComponent } from '@zerops/zui/relative-time';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZefPipesModule } from '@zerops/zef/pipes';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import {
  Domain,
  SslStatuses,
  DnsCheckStatuses,
  CdnStatuses
} from '@zerops/models/http-routing';
import { HttpRoutingItemTranslations } from '../http-routing-item.translations';
import { BadgeType, TriggerDnsCheckEvent } from '../http-routing-item.model';

@Component({
  selector: 'zui-badge-detail-popover',
  templateUrl: './badge-detail-popover.component.html',
  styleUrl: './badge-detail-popover.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatCardModule,
    RelativeTimeComponent,
    ZefProgressErrorModule,
    ZefScrollbarComponent,
    ZefCopyToClipboardModule,
    ZefPipesModule,
    ZuiSeparatorComponent
  ]
})
export class BadgeDetailPopoverComponent {

  // # Data
  // -- sync
  sslStatuses = SslStatuses;
  cdnStatuses = CdnStatuses;
  dnsStatuses = DnsCheckStatuses;

  // -- computed
  // Determine if SSL installation section should be shown
  showSslInstallation = computed(() => {
    const d = this.domain();
    return !!(d.sslStatus
      && d.sslStatus !== SslStatuses.Inactive
      && d.sslStatus !== SslStatuses.Active);
  });

  // Determine if SSL deployment section should be shown
  showSslDeployment = computed(() => {
    const d = this.domain();
    return !!(d.sslStatus && d.sslStatus !== SslStatuses.Inactive);
  });

  // # Inputs
  mode = input.required<BadgeType>();
  domain = input.required<Domain>();
  httpRoutingId = input.required<string>();
  translations = input.required<HttpRoutingItemTranslations>();
  triggerDnsCheckActionKey = input<string>();

  // # Outputs
  triggerDnsCheckClicked = output<TriggerDnsCheckEvent>();
  closePopover = output<void>();
}
